import { SchemaPlugin } from '@common/prosemirror/model/schema-plugin';
import { nodeToDOM } from '@common/util/schema';
import { NodeSpec } from 'prosemirror-model';

export class MadCapSlideshowSchemaPlugin extends SchemaPlugin {
  nodes = {
    madcapslideshow: {
      group: 'block',
      content: 'madcapslide+',
      isolating: true,
      parseDOM: [{
        tag: 'MadCap\\:slideshow'
      }],
      toDOM(node) { return nodeToDOM(node); },
      tagName: 'MadCap:slideshow',
      specContent: 'madcapslide'
    },

    madcapslide: {
      content: 'block+',
      fillIfContentDeleted: 'mcCentralContainer',
      isolating: true,
      parseDOM: [{ tag: 'MadCap\\:slide' }],
      toDOM(node) { return nodeToDOM(node); },
      tagName: 'MadCap:slide',
      specContext: 'madcapslideshow'
    }
  } satisfies Record<string, NodeSpec>;
}
